import { render, staticRenderFns } from "./DetalhesProposta.vue?vue&type=template&id=6ba06420&"
import script from "./DetalhesProposta.vue?vue&type=script&lang=js&"
export * from "./DetalhesProposta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports